<template>
  <div>
    <md-table
        v-model="sortedData"
        class="paginated-table table-striped table-hover"
    >
      <md-table-toolbar>
        <md-field>
          <label
          >{{ local_page_keys.table_pagination_users_on_the_page }}</label
          >
          <md-select
              v-model="pagination.perPage"
              name="pages"
              @input="changeCurrentPage"
          >
            <template v-for="item in pagination.perPageOptions">
              <md-option
                  v-if="item < total"
                  :label="item"
                  :value="item"
                  :key="item"
              >
                {{ item }}
              </md-option>
            </template>
            <md-option label="all" :value="total">All</md-option>
          </md-select>
        </md-field>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head
            v-for="header of headers"
            :key="header.id"
            :label="header.text"
            :md-sort-by="header.value"
        >
          {{ header.text }}
        </md-table-head>
      </md-table-row>
      <md-table-row v-for="user of getCurrPageData" :key="user.id">
        <template v-if="check_boxes_need">
          <md-table-cell
              v-for="header of headers"
              :key="header.id"
              :md-label="header.text"
              :md-sort-by="header.value"
          >
            <template v-if="header.value === 'user_name'">
              <v-checkbox
                  v-model="selectedToPay"
                  :label="user[header.value]"
                  :value="user.user_id"
                  @change="showChange"
              >
              </v-checkbox>
            </template>
         <template v-else>
              {{
                user[header.value]
              }}
            </template>
          </md-table-cell>
        </template>
        <template v-else>
          <md-table-cell
              v-for="header of headers"
              :key="header.id"
              :md-label="header.text"
              :md-sort-by="header.value"
          >{{
              user[header.value]
            }}
          </md-table-cell>
        </template>
      </md-table-row>
    </md-table>
    <md-card-actions md-alignment="space-between">
      <div>
        <p class="card-category">
          {{ local_page_keys.pagination_lable_showing }} {{ from + 1 }}
          {{
            local_page_keys.pagination_lable_to
          }}
          {{ to }}
          {{
            local_page_keys.pagination_lable_of
          }}
          {{ total }} {{ local_page_keys.pagination_entries }}
        </p>
      </div>
      <div>
        <md-button
            class="md-icon-button md-table-pagination-previous"
            @click="goToPrevious()"
            :disabled="pagination.currentPage === 1"
        >
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <span>{{ pagination.currentPage }} page of {{ total_page }}</span>
        <md-button
            class="md-icon-button md-table-pagination-next"
            @click="goToNext()"
            :disabled="pagination.currentPage === total_page"
        >
          <md-icon>keyboard_arrow_right</md-icon>
        </md-button>
      </div>
    </md-card-actions>
  </div>
</template>

<script>
import filterfortable from '../../../filters/filterfortable';
export default {
  name: "SalarySortedTable",
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    sortedData: {
      type: Array,
      require: true
    },
    headers: {
      type: Array,
      require: true
    },
    check_boxes_need: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },
      selectedToPay: [],
      sortation: {
        order: "desc",
        field: "all_amount",
      },
    }
  },
  methods: {
    filterfortable(header, value) {
      return filterfortable(header, value)
    },
    changeCurrentPage() {
      if (this.pagination.currentPage > this.total_page) this.pagination.currentPage = this.total_page;
    },
    goToNext() {
      this.pagination.currentPage++;
    },
    goToPrevious() {
      this.pagination.currentPage--;
    },
    showChange() {
      if (this.selectedToPay.length > 0) {
        this.$emit('select_to_pay', this.selectedToPay)
      }
    }
  },
  computed: {
    total() {
      return this.sortedData.length;
    },
    sort() {
      if (this.sortation.order === "desc") {
        return `-${this.sortation.field}`;
      }

      return this.sortation.field;
    },
    getCurrPageData() {
      return this.sortedData.slice(this.from, this.to);
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    total_page() {
      return Math.ceil(this.sortedData.length / this.pagination.perPage)
    }
  },
  created() {
    this.pagination.perPage = this.total;
  },
}
</script>

<style scoped></style>
